import React from "react";
import { FaCheckCircle } from "react-icons/fa";
import "./ContactFormBlock.css";

const ContactFormBlock = ({ form, handleChange, handleSubmit, submitted }) => {
  return (
    <div className="_cFrmB_k9P_">
      {submitted ? (
        <div className="_sMsgC_q5V_">
          <FaCheckCircle className="_sIcon_r6W_" />
          <h3 className="_sTitle_s7X_">Thank you for reaching out!</h3>
          <p className="_sTxt_t8Y_">
            We've received your message and will get back to you soon.
          </p>
        </div>
      ) : (
        <form onSubmit={handleSubmit} autoComplete="off" className="_cFrm_l0Q_">
          <label className="_fLbl_m1R_">
            Name
            <input
              type="text"
              name="name"
              value={form.name}
              onChange={handleChange}
              required
              className="_fInput_n2S_"
              placeholder="Your Name"
            />
          </label>

          <label className="_fLbl_m1R_">
            Email
            <input
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              required
              className="_fInput_n2S_"
              placeholder="your.email@example.com"
            />
          </label>

          <label className="_fLbl_m1R_">
            Phone Number
            <input
              type="tel"
              name="phone"
              value={form.phone || ""}
              onChange={handleChange}
              maxLength={15}
              className="_fInput_n2S_"
              placeholder="Your phone number"
            />
          </label>

          <label className="_fLbl_m1R_">
            Interested in
            <select
              name="interest"
              value={form.interest || ""}
              onChange={handleChange}
              className="_fInput_n2S_"
            >
              <option value="">Select an option</option>
              <option value="Representing a community">Representing a community</option>
              <option value="Becoming a seller">Becoming a seller</option>
            </select>
          </label>

          <label className="_fLbl_m1R_">
            Message
            <textarea
              name="message"
              value={form.message}
              onChange={handleChange}
              required
              rows={5}
              className="_fTarea_o3T_"
              placeholder="How can we help you?"
            />
          </label>

          <button
            type="submit"
            className="_sBtn_p4U_"
            // disabled={!form.name || !form.email || !form.message}
          >
            Send Message
          </button>
        </form>
      )}
    </div>
  );
};

export default ContactFormBlock;
